import { UAParser } from 'ua-parser-js';

export enum DeviceType {
  Mobile,
  Tablet,
  Desktop,
}
export interface Device {
  vendor: string | null;
  model: string | null;
}

export const getDeviceType = (
  userAgent: string
): {
  deviceType: DeviceType;
  device: Device;
} => {
  if (!userAgent) {
    return {
      deviceType: DeviceType.Desktop,
      device: { vendor: null, model: null },
    };
  }

  const parser = new UAParser(userAgent);
  const rawDevice = parser.getDevice();

  const device = {
    vendor: rawDevice?.vendor ?? null,
    model: rawDevice?.model ?? null,
  };
  switch (rawDevice.type) {
    case 'mobile':
      return { deviceType: DeviceType.Mobile, device };
    case 'tablet':
      return { deviceType: DeviceType.Tablet, device };
    default:
      return { deviceType: DeviceType.Desktop, device };
  }
};
